// Maps a store id (in the "store.<id>" firestore format) to the balance account
// whose bank transfers/payouts should be shown for that store. Use this when a
// store's payouts should be sourced from a specific balance account rather than
// the one stored on the store document.
export const storeBalanceAccountOverrides: Record<string, string> = {
  "store.ST329WV22322855M9972T89PL": "BA329Z922322C65PMR36H9Z3V",
};
